/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CustomersIdPaymenthistoryGet200ResponseInnerDiscount from './CustomersIdPaymenthistoryGet200ResponseInnerDiscount';

/**
 * The CustomersIdPaymenthistoryGet200ResponseInner model module.
 * @module model/CustomersIdPaymenthistoryGet200ResponseInner
 * @version 1.0.0
 */
class CustomersIdPaymenthistoryGet200ResponseInner {
    /**
     * Constructs a new <code>CustomersIdPaymenthistoryGet200ResponseInner</code>.
     * @alias module:model/CustomersIdPaymenthistoryGet200ResponseInner
     */
    constructor() { 
        
        CustomersIdPaymenthistoryGet200ResponseInner.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CustomersIdPaymenthistoryGet200ResponseInner</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CustomersIdPaymenthistoryGet200ResponseInner} obj Optional instance to populate.
     * @return {module:model/CustomersIdPaymenthistoryGet200ResponseInner} The populated <code>CustomersIdPaymenthistoryGet200ResponseInner</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CustomersIdPaymenthistoryGet200ResponseInner();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('amount')) {
                obj['amount'] = ApiClient.convertToType(data['amount'], 'String');
            }
            if (data.hasOwnProperty('amount_received')) {
                obj['amount_received'] = ApiClient.convertToType(data['amount_received'], 'String');
            }
            if (data.hasOwnProperty('created')) {
                obj['created'] = ApiClient.convertToType(data['created'], 'Date');
            }
            if (data.hasOwnProperty('currency')) {
                obj['currency'] = ApiClient.convertToType(data['currency'], 'String');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('type')) {
                obj['type'] = ApiClient.convertToType(data['type'], 'String');
            }
            if (data.hasOwnProperty('original_payment_intent')) {
                obj['original_payment_intent'] = ApiClient.convertToType(data['original_payment_intent'], 'String');
            }
            if (data.hasOwnProperty('discount')) {
                obj['discount'] = CustomersIdPaymenthistoryGet200ResponseInnerDiscount.constructFromObject(data['discount']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CustomersIdPaymenthistoryGet200ResponseInner</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CustomersIdPaymenthistoryGet200ResponseInner</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
            throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
        }
        // ensure the json data is a string
        if (data['amount'] && !(typeof data['amount'] === 'string' || data['amount'] instanceof String)) {
            throw new Error("Expected the field `amount` to be a primitive type in the JSON string but got " + data['amount']);
        }
        // ensure the json data is a string
        if (data['amount_received'] && !(typeof data['amount_received'] === 'string' || data['amount_received'] instanceof String)) {
            throw new Error("Expected the field `amount_received` to be a primitive type in the JSON string but got " + data['amount_received']);
        }
        // ensure the json data is a string
        if (data['currency'] && !(typeof data['currency'] === 'string' || data['currency'] instanceof String)) {
            throw new Error("Expected the field `currency` to be a primitive type in the JSON string but got " + data['currency']);
        }
        // ensure the json data is a string
        if (data['status'] && !(typeof data['status'] === 'string' || data['status'] instanceof String)) {
            throw new Error("Expected the field `status` to be a primitive type in the JSON string but got " + data['status']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        // ensure the json data is a string
        if (data['type'] && !(typeof data['type'] === 'string' || data['type'] instanceof String)) {
            throw new Error("Expected the field `type` to be a primitive type in the JSON string but got " + data['type']);
        }
        // ensure the json data is a string
        if (data['original_payment_intent'] && !(typeof data['original_payment_intent'] === 'string' || data['original_payment_intent'] instanceof String)) {
            throw new Error("Expected the field `original_payment_intent` to be a primitive type in the JSON string but got " + data['original_payment_intent']);
        }
        // validate the optional field `discount`
        if (data['discount']) { // data not null
          CustomersIdPaymenthistoryGet200ResponseInnerDiscount.validateJSON(data['discount']);
        }

        return true;
    }


}



/**
 * @member {String} id
 */
CustomersIdPaymenthistoryGet200ResponseInner.prototype['id'] = undefined;

/**
 * @member {String} amount
 */
CustomersIdPaymenthistoryGet200ResponseInner.prototype['amount'] = undefined;

/**
 * @member {String} amount_received
 */
CustomersIdPaymenthistoryGet200ResponseInner.prototype['amount_received'] = undefined;

/**
 * @member {Date} created
 */
CustomersIdPaymenthistoryGet200ResponseInner.prototype['created'] = undefined;

/**
 * @member {String} currency
 */
CustomersIdPaymenthistoryGet200ResponseInner.prototype['currency'] = undefined;

/**
 * @member {String} status
 */
CustomersIdPaymenthistoryGet200ResponseInner.prototype['status'] = undefined;

/**
 * @member {String} description
 */
CustomersIdPaymenthistoryGet200ResponseInner.prototype['description'] = undefined;

/**
 * Type of transaction
 * @member {module:model/CustomersIdPaymenthistoryGet200ResponseInner.TypeEnum} type
 */
CustomersIdPaymenthistoryGet200ResponseInner.prototype['type'] = undefined;

/**
 * @member {String} original_payment_intent
 */
CustomersIdPaymenthistoryGet200ResponseInner.prototype['original_payment_intent'] = undefined;

/**
 * @member {module:model/CustomersIdPaymenthistoryGet200ResponseInnerDiscount} discount
 */
CustomersIdPaymenthistoryGet200ResponseInner.prototype['discount'] = undefined;





/**
 * Allowed values for the <code>type</code> property.
 * @enum {String}
 * @readonly
 */
CustomersIdPaymenthistoryGet200ResponseInner['TypeEnum'] = {

    /**
     * value: "payment"
     * @const
     */
    "payment": "payment",

    /**
     * value: "refund"
     * @const
     */
    "refund": "refund"
};



export default CustomersIdPaymenthistoryGet200ResponseInner;

